import React from 'react';
import { useSelector } from 'react-redux';
import RailCheckout from '@components/cart/RailCheckout';
import CartReceiptHeader from '@components/cart/receipt/CartReceiptHeader';
import FreeShippingProgressBar from '@components/common/FreeShippingProgressBar';
import CartReceiptBody from '@components/cart/receipt/CartReceiptBody';
import WithYourPurchase from '@components/cart/recommendations/WithYourPurchase';
import YouMayAlsoLike from '@components/cart/recommendations/YouMayAlsoLike';
import ChevronIcon from '@components/icons/ChevronIcon';
import PairLogoSmall from '@components/common/PairLogoSmall';
import styles from './MinicartBody.module.scss';

const MinicartBody = ({ minicart = false }) => {
	const price = useSelector(state => state.cart.total_price);
	const isCanada = useSelector(state => state.cart.localization.country) === 'Canada';

	return (
		<div className={`minicart drawer drawer-right hiding justify-content-between ${styles.minicart}`} data-drawer='minicart'>
			<div className='site-header__cart-header site-header__drawer-control site-header__thin blue-text d-flex justify-content-center align-items-center'>
				<a onClick={() => handleDrawerClick('minicart')} className='button button-small'>
					<ChevronIcon direction='left' color='#080593' />
					Back
				</a>
				<a href='/' className='logo d-flex align-items-center'>
					<PairLogoSmall />
				</a>
			</div>
			<CartReceiptHeader minicart />
			{isCanada ? <FreeShippingProgressBar isMiniCart /> : null}
			<CartReceiptBody />
			<div className={`cart-item__wrap ${minicart ? styles.miniCart : styles.marginCart}`}>
				<WithYourPurchase minicart />
			</div>
			<div className={`cart-item__wrap ${minicart ? styles.miniCart : styles.marginCart}`}>
				<YouMayAlsoLike minicart />
			</div>
			<RailCheckout price={price} />
		</div>
	);
};

export default MinicartBody;
